// import history from "@history.js";
import { createSlice } from "@reduxjs/toolkit";

import jwtAuthService from "app/services/jwtAuthService";
import localStorageService from "app/services/localStorageService";
import FirebaseAuthService from "app/services/firebase/firebaseAuthService";

// Retrieve the auth_user from localStorage
const storedUser = localStorageService.getItem("auth_user");

// Check if storedUser has accessToken property
const isAuthenticated = storedUser && storedUser.accessToken ? true : false;

const initialState = {
  loading: false,
  success: false,
  user: storedUser && storedUser.user ? storedUser.user : {}, // ✅ ensure user is never undefined/null
  errorMessage: null,
  accessToken: storedUser ? storedUser.accessToken : undefined,
  externalToken: storedUser ? storedUser.externalToken : undefined,
  isAuthenticated,
  error: { username: null, password: null }
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // ✅ Correct: use Object.assign or return a new object
    setUserData: (state, action) => {
      Object.assign(state, action.payload);
    },

    // ✅ Works fine: mutate directly (immer handles it)
    userLoggedIn: (state, action) => {
      const user = action.payload.user || {};

      state.isAuthenticated = true;
      state.accessToken = action.payload.accessToken;
      state.externalToken = action.payload.externalToken || undefined;
      state.user = user;

      localStorageService.setItem("auth_user", {
        accessToken: action.payload.accessToken,
        externalToken: action.payload.externalToken,
        user
      });
    },

    userLoggedOut: (state) => {
      state.isAuthenticated = false;
      state.accessToken = undefined;
      state.externalToken = undefined;
      state.user = {};
      localStorage.removeItem("auth_user");
    },

    resetPassword: (state, action) => {
      state.success = true;
      state.loading = false;
      console.log(action.payload.email);
    },

    requestStart: (state) => {
      state.loading = true;
    },

    // ✅ Fixed: return a new state object
    loginWithEmailAndPassword: (state, action) => {
      try {
        const user = action.payload;
        localStorageService.setItem("auth_user", { accessToken: user.token, user });

        return {
          ...state,
          user,
          success: true,
          loading: false,
          isAuthenticated: true,
          accessToken: user.token
        };
      } catch (error) {
        console.log(error);
        return { ...state, loading: false, success: false };
      }
    },

    // ✅ No change needed except safer mutation
    firebaseLoginEmailPassword: (state, action) => {
      const { email, password } = action.payload;
      state.loading = true;

      FirebaseAuthService.signInWithEmailAndPassword(email, password)
        .then((user) => {
          if (user) {
            state.user = {
              ...user,
              userId: "1",
              role: "ADMIN",
              displayName: "Watson Joyce",
              email: "watsonjoyce@gmail.com",
              photoURL: "/assets/images/face-7.jpg",
              age: 25,
              token: "faslkhfh423oiu4h4kj432rkj23h432u49ufjaklj423h4jkhkjh"
            };

            state.success = true;
            state.loading = false;
          } else {
            state.success = false;
            state.loading = false;
          }
        })
        .catch((error) => {
          state.success = false;
          state.loading = false;
          state.error = error.data;
        });
    },

    logoutJWTUser: (state) => {
      jwtAuthService.logout();
      state.user = {};
      state.isAuthenticated = false;
    }
  }
});

export const {
  setUserData,
  userLoggedIn,
  userLoggedOut,
  resetPassword,
  logoutJWTUser,
  loginWithEmailAndPassword,
  firebaseLoginEmailPassword
} = authSlice.actions;

export default authSlice.reducer;
